export var ExternalBalanceTypeEnum;
(function (ExternalBalanceTypeEnum) {
    ExternalBalanceTypeEnum["MAIN"] = "MAIN";
    ExternalBalanceTypeEnum["TRADE"] = "TRADE";
    ExternalBalanceTypeEnum["UNIFIED"] = "UNIFIED";
    ExternalBalanceTypeEnum["FUND"] = "FUND";
    ExternalBalanceTypeEnum["CREDIT"] = "CREDIT";
    ExternalBalanceTypeEnum["USED_CREDIT"] = "USED_CREDIT";
})(ExternalBalanceTypeEnum || (ExternalBalanceTypeEnum = {}));
//# sourceMappingURL=external-balance-type.enum.js.map